import React, { FC } from 'react';
import { Box, Stack, Typography, SvgIcon } from '@mui/material';
import { ResizeObserver } from '@juggle/resize-observer';
import useMeasure from 'react-use-measure';
import styles from './SliderComponent.module.scss';
import PhysicalIcon from '../../../assets/physical.svg';
import VitalsIcon from '../../../assets/vitals.svg';
import PhysiologicalIcon from '../../../assets/physiological.svg';
import boddVariables from '../../../variables.module.scss';
import { clamp, WellnessItem } from '../../../services/DataFormatService';

interface SliderComponentProps {
    wellnessItem: WellnessItem,
}

const SliderComponent: FC<SliderComponentProps> = (props) => {
    const { wellnessItem } = props;
    const [ref, bounds] = useMeasure({ polyfill: ResizeObserver });
    const valLeft = clamp((wellnessItem.value / 5) * bounds.width, bounds.width - 15);

    return (
        <Stack className={styles.SliderComponent} data-testid="SliderComponent" sx={{ py: 1 }}>
            <Stack direction="row" justifyContent="space-between">
                <Stack direction="row" alignItems="flex-start" spacing={1}>
                    {wellnessItem.name === 'Vitals' && <SvgIcon sx={{ width: 20, height: 20 }}><VitalsIcon /></SvgIcon>}
                    {wellnessItem.name === 'Physiological' && <SvgIcon sx={{ width: 20, height: 20 }}><PhysiologicalIcon /></SvgIcon>}
                    {wellnessItem.name === 'Physical' && <SvgIcon sx={{ width: 20, height: 20 }}><PhysicalIcon /></SvgIcon> }
                    <Typography sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '14px',
                        color: boddVariables.black,
                    }}
                    >
                        {wellnessItem.name}
                    </Typography>
                </Stack>
                <Typography
                    alignContent="right"
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '600',
                        fontSize: '14px',
                        color: boddVariables.black,
                    }}
                >
                    {wellnessItem.formattedValue}
                    /5.0
                </Typography>
            </Stack>
            <Box className={styles.ScoreBar} ref={ref} sx={{ height: 7, my: 1 }}>
                <Box
                    sx={{
                        height: 15,
                        width: 15,
                        border: '2px',
                        borderStyle: 'solid',
                        borderColor: boddVariables.white,
                        backgroundColor: boddVariables.black,
                        position: 'relative',
                        left: `${valLeft}px`,
                        borderRadius: '50%',
                        top: '-6px',
                    }}
                />
            </Box>
        </Stack>
    );
};

export default SliderComponent;
